import { handleActions } from 'redux-actions'
import { addPopupStatus } from 'actions/addPopup'

const defaultState = {
  open: false,
  type: null
}

const reducer = handleActions(
  {
    [addPopupStatus]: (
      state,
      {
        payload: {
          data: { status }
        }
      }
    ) => {
      return status
    }
  },
  defaultState
)

export default reducer
